module.exports = __webpack_public_path__ + "img/trip_sendai10.94de51fa.jpg";